var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsNotEmpty, IsOptional, IsString, MaxLength, } from 'class-validator';
import { AdminNoticeCategory } from '../../../enums/admin-notice/admin-notice-category.enum';
export const ADMIN_NOTICE_TITLE_MAX_LENGTH = 255;
// Markdown body. MEDIUMTEXT holds far more; this keeps a pasted mistake from bloating every list response.
export const ADMIN_NOTICE_CONTENT_MAX_LENGTH = 200000;
export class CreateAdminNoticeDto {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    MaxLength(ADMIN_NOTICE_TITLE_MAX_LENGTH),
    __metadata("design:type", String)
], CreateAdminNoticeDto.prototype, "title", void 0);
__decorate([
    IsString(),
    MaxLength(ADMIN_NOTICE_CONTENT_MAX_LENGTH),
    __metadata("design:type", String)
], CreateAdminNoticeDto.prototype, "content", void 0);
__decorate([
    IsEnum(AdminNoticeCategory),
    __metadata("design:type", String)
], CreateAdminNoticeDto.prototype, "category", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateAdminNoticeDto.prototype, "pinned", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateAdminNoticeDto.prototype, "published", void 0);
